import styled from 'styled-components'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { typography, space, layout, flexbox, color, grid, position } from 'styled-system'

const headingSizes = {
	h1: 5,
	h2: 4,
	h3: 3,
	h4: 2,
}

const headingLineHeights = {
	h1: 1,
	h2: 1.1,
	h3: 1.25,
	h4: 1.5,
}

/**
 * Heading component.
 *
 * This component renders a styled heading element with additional styles and attributes.
 *
 * @component
 * @example
 * // Usage example:
 * <Heading fontSize={5} color="primary">Styled Heading</Heading>
 *
 * @param {Object} props - The props that are passed to the component.
 * @returns {JSX.Element} The Heading component.
 */
export const Heading = styled('h1')
	.withConfig({ shouldForwardProp })
	.attrs((props) => ({
		fontFamily: 'system-ui, sans-serif',
		fontSize: headingSizes[props.as || 'h1'],
		lineHeight: headingLineHeights[props.as || 'h1'],
		mt: 0,
		mb: 0,
		...props,
	}))({}, typography, space, layout, flexbox, color, grid, position)

Heading.displayName = 'Heading'
